export default [
  'rfq.create',
  'rfq.read',
  'rfq.update',
  'rfq.delete',
  'order.create',
  'order.read',
  'order.update',
  'order.delete',
  'newRfq.create',
  'newRfq.read',
  'newRfq.update',
  'newRfq.delete',
];
